import { createElement } from 'react'
import { FlagCell } from 'routes/shared/components'
import { Table } from 'shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Update } from '../shared/local/components/updateButton'

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
    maxWidth: 100,
    width: 100,
  },
  {
    Header: 'Name',
    accessor: 'tournamentName',
    maxWidth: 300,
    width: 300,
  },
  {
    Header: 'Sport',
    accessor: 'sportType',
  },
  {
    Header: 'Jurisdiction',
    accessor: 'jurisdiction.logo',
    Cell: FlagCell,
  },
  {
    Header: 'Start date',
    accessor: 'startTime',
    Cell: Table.CellRenderers.DateTimeCell,
    maxWidth: 200,
    width: 200,
  },
  {
    Header: 'End date',
    accessor: 'endTime',
    Cell: Table.CellRenderers.DateTimeCell,
    maxWidth: 200,
    width: 200,
  },
  {
    Header: 'Marketing Promotion',
    accessor: 'marketingPromotion',
    Cell: (props) => {
      return props.value ? 'Yes' : 'No'
    },
    maxWidth: 220,
    width: 220,
  },
  {
    Header: 'Update',
    id: 'controls',
    accessor: (value) => value,
    Cell: (props) => createElement(Update, { ...props }),
    maxWidth: 130,
    width: 130,
  },
]
